import './real-estate-search-result/real-estate-search-result/real-estate-search-result.module';
